import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-tipos',
    templateUrl: '../../pages/tipos/tipos.component.html',
    styleUrls: ['../../pages/tipos/tipos.component.css']
})
export class TiposComponent implements OnInit 
{
    constructor() { }

    ngOnInit(): void { }
}